import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { CitietouristicService } from 'src/app/api/tourism/citietouristic.service';
import { TypehotelService } from 'src/app/api/config/typehotel.service';
import { GeneralService } from 'src/app/api/config/general.service';
import { TypebedroomService } from 'src/app/api/config/typebedroom.service';
import { ServicehotelService } from 'src/app/api/config/servicehotel.service';
import { NgModel } from '@angular/forms';
import { ToolsService } from 'src/app/utils/tools.service';
import { constants } from 'src/app/constants';
import { HotelService } from 'src/app/api/tourism/hotel.service';
import { ServicehotelExtendsComponent } from 'src/app/config/servicehotel/servicehotel-extends/servicehotel-extends.component';
import { HotelMenutabComponent } from '../hotel-menutab/hotel-menutab.component';
import SwalAlert from 'src/app/utils/swalalert';
import { HttpHeaders } from '@angular/common/http';
import { ServicehotelListComponent } from 'src/app/config/servicehotel/servicehotel-list/servicehotel-list.component';
declare var $: any;

@Component({
  selector: 'app-hotel-form',
  templateUrl: './hotel-form.component.html',
  styleUrls: ['./hotel-form.component.css']
})
export class HotelFormComponent implements OnInit {
  @ViewChild(ServicehotelListComponent) ServicehotelListComponent: any;
  @ViewChild(ServicehotelExtendsComponent) ServicehotelExtendsComponent: any;

  branchofficeSlug: string = '';
  nameMenu: string = 'information_general';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;
  save_add: boolean = false;

  typeBedroomSelected: any = constants.typeBedroomSelected;
  serviceHotelSelected: any = constants.serviceHotelSelected;

  typeshotel: any;
  citiestouristic: any;
  categoriesstars: any;
  typesbedroom: any;
  serviceshotel: any;
  // Este array almacenará los servicios seleccionados (por id)
  selectedServicesHotel: number[] = [];

  detail_typesbedroom: any = [];
  detail_serviceshotel: any = [];
  // fortmat pdf
  selectedPdfFile: any | null = null;

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private routeActivated: ActivatedRoute,
    private el: ElementRef,
    private renderer: Renderer2,
    private globalService: GlobalService,
    private hotelService: HotelService,
    private generalService: GeneralService,
    private citieTouristicService: CitietouristicService,
    private typeHotelService: TypehotelService,
    private typeBedroomService: TypebedroomService,
    private serviceHotelService: ServicehotelService,
    private alertifyMsg: AlertifyHelper,
    private toolsService: ToolsService,
    private alert: SwalAlert,
    private navigationTrackerService: NavigationTrackerService
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.routeActivated.snapshot.params['id'];
    this.item = this.fb.group({
      tradename: [null, [Validators.required, Validators.minLength(2)]],
      typehotel_id: [null, [Validators.required]],
      citietouristic_id: [null, [Validators.required]],
      category: [null],
      document: [null],
      fullname: [null, [Validators.minLength(2), Validators.maxLength(255)]],
      cellphone: [null],
      telephone: [null],
      email: [null],
      address: [null],
      checkin: [null],
      checkout: [null],
      is_top_web: [false],
      price_package: [null],
      description: [null],
      iframe_map: [null],
      url_file: [null],
      link_external_web: [null],
      link_external_video: [null],
      detail_typesbedroom: this.fb.array([])
    });

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;     
    }
  }

  ngOnInit() {
    this.navigationTrackerService.initializeMenu(this.routeActivated);
    // set initial values =============
    this.getTypeHotel();
    this.getCitieTouristic();
    this.getCategoryStars();
    this.getTypeBedroom();
    this.getServiceHotel();
    (<any>$('[data-toggle="tooltip"]')).tooltip();
    if (this.isEdit) {
      this.editData();
    }
  }

  editData(){
    this.hotelService.get(this.checkId).subscribe({
      next: (data: any) => {
        let _item = data.data;
        this.item.patchValue({
          tradename: _item.tradename,
          typehotel_id: _item.typehotel_id,
          citietouristic_id: _item.citietouristic_id,
          category: _item.category,
          document: _item.document,
          fullname: _item.fullname,
          cellphone: _item.cellphone,
          telephone: _item.telephone,
          email: _item.email,
          address: _item.address,
          checkin: _item.checkin,
          checkout: _item.checkout,
          is_top_web: _item.is_top_web,
          price_package: _item.price_package,
          description: _item.description,
          iframe_map: _item.iframe_map,
          url_file: _item.url_file,
          link_external_web: _item.link_external_web,
          link_external_video: _item.link_external_video,
        });

        // detail_typesbedroom
        for (let i in _item.hotelprices) {
          const _obj = this.fb.group(_item.hotelprices[i]);
          (this.item.get('detail_typesbedroom') as FormArray).push(_obj);
        }

        // detail_serviceshotel
        this.detail_serviceshotel = _item.serviceshotel;
        this.loadSelectedServices(); // cargar servicios ya asociados
      }
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  // FUNCTIONS LOADS DATAS

  loadSelectedServices() {
    // Asegúrate de que detail_serviceshotel esté disponible antes de llamar esto
    this.selectedServicesHotel = this.detail_serviceshotel.map((s: any) => s.id);
  }
  
  isSelectedService(id: number): boolean {
    return this.selectedServicesHotel.includes(id);
  }
  
  toggleService(service: any) {
    const index = this.selectedServicesHotel.indexOf(service.id);
    if (index > -1) {
      // si ya está, quitarlo
      this.selectedServicesHotel.splice(index, 1);
    } else {
      // si no está, agregarlo
      this.selectedServicesHotel.push(service.id);
    }
  }

  getTypeHotel() {
    this.typeHotelService.all().subscribe({
      next: (data: any) => {
        this.typeshotel = data.results;
      }
    });
  }

  getCitieTouristic() {
    this.citieTouristicService.all().subscribe({
      next: (data: any) => {
        this.citiestouristic = data.results;
      }
    });
  }

  getCategoryStars() {
    this.generalService.listCategoryStars().subscribe({
      next: (data: any) => {
        this.categoriesstars = data;
      }
    });
  }

  getTypeBedroom() {
    this.typeBedroomService.all().subscribe({
      next: (data: any) => {
        this.typesbedroom = data.results;
      }
    });
  }

  getServiceHotel() {
    this.serviceHotelService.all().subscribe({
      next: (data: any) => {
        this.serviceshotel = data.results;
      }
    });
  }

  //  ===========================

  // addTypeBedroom() {
  //   let obj_ = this.toolsService.searchArrById(
  //     this.typeBedroomSelected,
  //     this.typesbedroom
  //   );
  //   if (this.toolsService.notExistObjInArr(obj_, this.detail_typesbedroom)) {
  //     obj_.detail_id = null;
  //     obj_.price_sale = null;
  //     obj_.price_corporate = null;
  //     obj_.observation = null;
  //     this.detail_typesbedroom.push(obj_);
  //   } else {
  //     this.alertifyMsg.warning(
  //       'El item ' + obj_.description + ' ya se encuentra agregado'
  //     );
  //   }
  // }

  // removeTypeBedroom(id: any, index: any) {
  //   this.detail_typesbedroom.splice(index, 1);
  // }

  getDetailTypesBedroom() {
    return (this.item.get('detail_typesbedroom') as FormArray).controls;
  }

  addDetailTypesBedroom() {
    // let obj_ = this.toolsService.searchArrById(
    //   this.typeBedroomSelected,
    //   this.typesbedroom
    // );

    // const _item = this.fb.group({
    //   description: [obj_.description],
    //   detail_id: [null],
    //   price_sale: [null],
    //   price_corporate: [null],
    //   price_high: [null],
    //   observation: [null],
    // });
    // (this.item.get('detail_typesbedroom') as FormArray).push(_item);
    let obj_:any = {};
    obj_.id = null;
    obj_.detail_id = null;
    obj_.description = null;
    obj_.number_guests = null;
    obj_.price_sale = null;
    obj_.price_corporate = null;
    obj_.price_high = null;
    obj_.observation = null;
    const _item = this.fb.group(obj_);
    (this.item.get('detail_typesbedroom') as FormArray).push(_item);

    // if (
    //   this.toolsService.notExistObjInArr(
    //     obj_,
    //     this.item.value.detail_typesbedroom
    //   )
    // ) {
    //   obj_.detail_id = null;
    //   obj_.number_guests = obj_.number_guests;
    //   obj_.price_sale = null;
    //   obj_.price_corporate = null;
    //   obj_.price_high = null;
    //   obj_.observation = null;
    //   const _item = this.fb.group(obj_);
    //   (this.item.get('detail_typesbedroom') as FormArray).push(_item);
    // } else {
    //   this.alertifyMsg.warning(
    //     'El item ' + obj_.description + ' ya se encuentra agregado'
    //   );
    // }
  }

  removeDetailTypeBedroom(index: number) {
    (this.item.get('detail_typesbedroom') as FormArray).removeAt(index);
  }

  addServiceHotel() {
    let obj_ = this.toolsService.searchArrById(
      this.serviceHotelSelected,
      this.serviceshotel
    );
    if (this.toolsService.notExistObjInArr(obj_, this.detail_serviceshotel)) {
      this.detail_serviceshotel.push(obj_);
    } else {
      this.alertifyMsg.warning(
        'El servicio ' + obj_.description + ' ya se encuentra agregado'
      );
    }
  }

  removeServiceHotel(id: any, index: any) {
    this.detail_serviceshotel.splice(index, 1);
  }

  // changePriceNormalTypeBedroom(param: any, index: number): void {
  //   // console.log('New value:', param);
  //   // console.log('New value:', param.value);
  //   // console.log(this.detail_typesbedroom[index]);
  //   if (!_.isNaN(param.value * 1)) {
  //     this.detail_typesbedroom[index].price_sale = param.value;
  //   }
  // }

  // changePriceCorporateTypeBedroom(param: any, index: number): void {
  //   if (!_.isNaN(param.value * 1)) {
  //     this.detail_typesbedroom[index].price_corporate = param.value;
  //   }
  // }

  // changeObservationTypeBedroom(param: any, index: number): void {
  //   this.detail_typesbedroom[index].price_corporate = param.value;
  // }

  onFileSelected(event: any): void {
    const file: File = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      if (this.validateSizeImg(file)) {
        this.selectedPdfFile = file;
      }
    } else {
      this.selectedPdfFile = null;
      (<any>$('#file_pdf')).val(null);
      // alert('Por favor, seleccione un archivo PDF.');
      this.alert.warning('Por favor, seleccione un archivo PDF.');
    }
  }

  validateSizeImg(file: any, isMulti: boolean = false) {
    const maxSize = 1024 * 1024; // 1MB in bytes
    if (file) {
      if (file.size / maxSize > environment.max_size_file) {
        let _txt = 'El tamaño del archivo seleccionado (' + file.name + ')';
        this.alertifyMsg.warning(
          _txt +
            ' excede el límite permitido (1 MB). Elija un archivo más pequeño; ó reduzca el tamaño del archivo.',
          10
        );
        return false;
      }
    }

    return true;
  }

  removeFilePdf() {
    this.item.patchValue({
      url_file: null
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }

    let data: any = {};
    if (this.validate()) {
      data.item = this.item.value;
      // data.detail_typesbedroom = this.item.value.detail_typesbedroom;
      // data.detail_serviceshotel = this.detail_serviceshotel;
      // let custom_services:any = [];
      // let temps_services:any = [];
      // for(let i in this.selectedServicesHotel){
      //   temps_services.push(this.selectedServicesHotel[i]);
      //   for(let j in this.detail_serviceshotel){
      //     if(this.selectedServicesHotel[i] == this.detail_serviceshotel[j].id){
      //       custom_services.push(this.detail_serviceshotel[j]);
      //       temps_services.pop();
      //       break;
      //     }
      //   }
      // }

      // for(let i in temps_services){
      //   for(let j in this.serviceshotel){
      //     if(temps_services[i] == this.serviceshotel[j].id){
      //       custom_services.push(this.serviceshotel[j]);
      //       break;
      //     }
      //   }
      // }

      // console.log(custom_services);
      // console.log(temps_services);
      let custom_services: any[] = [];
      for (let selectedId of this.selectedServicesHotel) {
        const servicio =
          this.detail_serviceshotel.find((s: { id: number }) => s.id === selectedId) ||
          this.serviceshotel.find((s: { id: number }) => s.id === selectedId);
        if (servicio) {
          custom_services.push(servicio);
        }
      }
      this.detail_serviceshotel = custom_services;
      
      const formData = new FormData();
      const headers = new HttpHeaders();
      headers.append('Content-Type', 'multipart/form-data');
      headers.append('Accept', 'application/json');
      formData.append('item', JSON.stringify(data));
      formData.append(
        'detail_typesbedroom',
        JSON.stringify(this.item.value.detail_typesbedroom)
      );
      formData.append(
        'detail_serviceshotel',
        JSON.stringify(this.detail_serviceshotel)
      );
      formData.append('url_file', this.selectedPdfFile);

      if (this.isEdit) {
        formData.append('id', JSON.stringify(this.checkId));
        this.hotelService.updateSave(formData).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro actualizado con éxito');
            // this.routerBack();
            const detailTypesBedroomArray = this.item.get('detail_typesbedroom') as FormArray;
            detailTypesBedroomArray.clear();
            this.editData();
          }
        });
      } else {
        this.hotelService.save(formData).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro realizado con éxito');
            this.routerBack();
          }
        });
      }
    }
  }

  validate() {
    //  validate type bedrooms
    let _dataform = this.item.value;
    if (_dataform.detail_typesbedroom.length > 0) {
      for (let i in _dataform.detail_typesbedroom) {
        let _item = _dataform.detail_typesbedroom[i];

        let _element_typebedroom_price_corporate = this.el.nativeElement.querySelector(
          '#typebedroom_price_corporate' + i
        );
        if (
          Number(_item.price_corporate) == 0 ||
          _.isNull(_item.price_corporate)
        ) {
          this.alertifyMsg.warning(
            'El precio corporativo de la ' +
              _item.description +
              ' no puede ser igual a cero o estar vacío.'
          );
          this.renderer
            .selectRootElement(_element_typebedroom_price_corporate)
            .focus();
          return false;
        }

        let _element_typebedroom_price_sale = this.el.nativeElement.querySelector(
          '#typebedroom_price_sale' + i
        );
        if (Number(_item.price_sale) == 0 || _.isNull(_item.price_sale)) {
          this.alertifyMsg.warning(
            'El precio normal de la ' +
              _item.description +
              ' no puede ser igual a cero o estar vacío.'
          );
          this.renderer
            .selectRootElement(_element_typebedroom_price_sale)
            .focus();
          return false;
        }
      }
    }

    return true;
  }

  resetForm() {
    this.submitted = false;
    this.item.reset();
    (<any>$('#item_description')).focus();
  }

  cancel() {
    this.routerBack();
  }
  routerBack() {
    this.router.navigate([this.branchofficeSlug + '/turismo/hoteles/lista']);
  }

  extendsServiceHotel(event: any): void {
    this.getServiceHotel();
    this.serviceHotelSelected = event.id;
  }

  extendsServiceHotelList(event: any): void {
    this.getServiceHotel();
    this.loadSelectedServices();
  }
}
